module.exports = __webpack_public_path__ + "static/media/SILAB.3a4f0fd6.png";